import React, { Component } from 'react';
import TableCell from './TableCell';
import PropTypes from 'prop-types';
import TableSorter from "../../common/components/TableSorter"

class DashboardTable extends Component {

  handleCheckboxChange = (e, studyId) => {
    const isChecked = e.target.checked;
    const selectedStudies = this.props.selectedStudies || [];

    const updatedSelectedStudies = isChecked
      ? [...new Set([...selectedStudies, studyId])]
      : selectedStudies.filter((id) => id !== studyId);

    if (this.props.onStudiesSelection) {
      this.props.onStudiesSelection(updatedSelectedStudies);
    }
  };

  handleHeaderCheckboxChange = (e) => {
    if (this.props.onSelectAllStudies) {
      this.props.onSelectAllStudies(e.target.checked);
    }
  };
  render() {
  const {
    handleSortChange,
    currentOrderBy,
    studies,
    onToggleQualityChecks,
    pendingQualityChecksByStudyId,
    canEditQualityChecks,
    selectedStudies = [],
    allCurrentPageSelected,
    someCurrentPageSelected,
    selectAllLoading,
  } = this.props;


    return (
        <div
    className="dashboard-table-scroll"
    style={{
      width: "100%",
      overflowX: "auto",
      overflowY: "scroll",
      WebkitOverflowScrolling: "touch",
      height: "65vh"
    }}
  >
    <table
      className="table"
      style={{
        minWidth: "max-content",
        width: "100%",
      }}
    >
      <tbody>
        <tr>
          <th style={{ width: 48, paddingLeft: 16}}>
            <input
              type="checkbox"
              checked={!!allCurrentPageSelected}
              disabled={!!selectAllLoading}
              ref={(el) => {
                if (el) {
                  el.indeterminate = !!someCurrentPageSelected;
                }
              }}
              onChange={this.handleHeaderCheckboxChange}
              style={{
                width: "16px",
                height: "16px",
                cursor: "pointer",
              }}
            />
          </th>

    {/* study Id */}
    <th style={{textAlign: "left", paddingleft: "16px", display: "flex"}}>
      <h4 style={{diaplay: "inline"}}>Study Id</h4>
      {currentOrderBy ? (
        <TableSorter
          name="STUDY ID"
          handleSortChange={handleSortChange}
          currentOrderBy={currentOrderBy}
        />
      ) : (
        ""
        )}
    </th>

  {/*study name header cell */}
  <th
    style={{
      paddingLeft: 30,    
      width: "18%",
      borderTopLeftRadius: 8,
      borderBottomLeftRadius: 8,
      boxShadow: "none", 
    }}
  >
    <h4 style={{ display: "inline" }}>Study name</h4>
    {currentOrderBy ? (
      <TableSorter
        name="Name"
        handleSortChange={handleSortChange}
        currentOrderBy={currentOrderBy}
      />
    ) : (
      ""
    )}
  </th>
  
            <th>
            <h4 style={{display: "inline"}}>Environment</h4>
            </th>

            <th >
            <h4 style={{display: "inline"}} >Media</h4>            
            </th>

            
            
                       
            <th style={{ textAlign: "center", paddingLeft: "16px", minWidth: 150 }}>
              <h4 style={{ display: "inline" }}>Quality Checks Enabled</h4>
            </th>

            <th style={{ textAlign: "center", paddingLeft: "16px", minWidth: 150 }}>
              <h4 style={{ display: "inline" }}>System Pause Override</h4>
            </th>

             <th style={{ textAlign: "left", paddingLeft: "16px" }}>
              <h4 style={{ display: "inline" }}>Phase</h4>
            </th>
 
             <th style={{ textAlign: "left", paddingLeft: "16px" }}>
             <h4 style={{ display: "inline" }}>Status</h4>
              </th>

             <th style={{ textAlign: "left", paddingLeft: "16px" }}>
            <h4 style={{ display: "inline" }}>Phase Colour</h4>
           </th>

            <th
            className="paddingRightWhen1200"
            style={{ textAlign: "right", paddingRight: "16px" }}
            >
            <h4 style={{ display: "inline" }}>
            Participants <br /> Returned
            </h4>
            </th>
            <th className="RemoveColumnWhen1200" ><h4>Fieldwork Start</h4>
            </th>
            <th className="RemoveColumnWhen1350" style={{paddingRight: "16px", borderTopRightRadius: 8, borderBottomRightRadius:8, boxShadow: "rgb(255 255 255) -16px 0px 0px inset", textAlign:"left" }}><h4>Fieldwork End</h4>
            </th>
        
          </tr>

{(studies || []).map((item, key) => {
  const studyId = item.study_id;

  const qualityChecksEnabledFromApi =
    typeof item.phase_colour_system_processing_enabled === "boolean"
      ? item.phase_colour_system_processing_enabled
      : false;

  const systemPauseOverrideFromApi =
    typeof item.phase_colour_system_paused_override === "boolean"
      ? item.phase_colour_system_paused_override
      : false; 

  const hasPending =
    pendingQualityChecksByStudyId &&
    Object.prototype.hasOwnProperty.call(pendingQualityChecksByStudyId, studyId);

  const displayedQualityChecksEnabled = hasPending
    ? !!pendingQualityChecksByStudyId[studyId]
    : qualityChecksEnabledFromApi;

  return (
    <TableCell
      onClick={this.onClick}
      id={studyId}
      title={item.name}
      environment={item.environment == null ? "" : String(item.environment)}
      media={item.media == null ? "" : String(item.media)}
      phase={item.phase}
      phase_status={item.phase_status}
      phase_colour_id={item.phase_colour_id}
      phase_colour={item.phase_colour}
      participants_requested={item.participants_requested}
      participants_returned={item.participants_returned}
      data_collection_start={item.data_collection_start}
      data_collection_end={item.data_collection_end}
      key={key}
      qualityChecksEnabled={displayedQualityChecksEnabled}
      systemPauseOverride={systemPauseOverrideFromApi}
      onToggleQualityChecks={onToggleQualityChecks}
      disableQualityChecksToggle={!canEditQualityChecks}
      selected={selectedStudies.includes(studyId)}
      onSelectChange={this.handleCheckboxChange}
    />
  );
})}

     
        </tbody>
      </table>
      </div>
    );
  }
}

DashboardTable.propTypes = {
  name: PropTypes.string, 
  id: PropTypes.number,
  title: PropTypes.string,
  environment: PropTypes.string,
  media: PropTypes.string,
  participants_requested: PropTypes.number,
  participants_returned: PropTypes.number,
  data_collection_start: PropTypes.string,
  data_collection_end: PropTypes.string,
  studies: PropTypes.array,
  onToggleQualityChecks: PropTypes.func,
  pendingQualityChecksByStudyId: PropTypes.object,
  canEditQualityChecks: PropTypes.bool,
  selectedStudies: PropTypes.array,
  onStudiesSelection: PropTypes.func,
  onSelectAllStudies: PropTypes.func,
  allCurrentPageSelected: PropTypes.bool,
  someCurrentPageSelected: PropTypes.bool,
  selectAllLoading: PropTypes.bool,
};

export default DashboardTable;